
import { Box, Typography, Button, useMediaQuery, useTheme } from "@mui/material";
import './products.css';

import BG from '../../../assets/images/BG_Products_Home.png'

function Products() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const titleVariant = isMobile ? "h5" : "h4";

  return (
    <Box className="product-container">
      <Box
        className="product-title"
        sx={{
          height: "184px",
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          className="title-head"
          sx={{
            color: "#E66671",
            fontWeight: "bold",
            textAlign: "center",
            fontFamily: "BloodOrange, sans-serif",
          }}
        >
          ✧ Enamórate de nuestros productos ✧
        </Typography>
      </Box>
      <Box
      className="product-bg-container"
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* Imagen de fondo */}
        <Box
          component="img"
          className="product-bg"
          alt="Productos Marián"
          src={BG}
        />
        <Box
          className="product-square"
        >
          <Box className="product-square-content">
            <Typography
              className="product-square-title"
              sx={{
                fontWeight: "bold",
                color: "#3D1C02",
                fontFamily: "BloodOrange, sans-serif"
              }}
            >
              Amamos las tartaletas
            </Typography>
            <Typography
              className="product-square-description"
              sx={{
                fontWeight: "600",
                color: "#3D1C02",
                width: "400px",
                textAlign: "center",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              Su base suave y dulce centro de mermelada es ideal para acompañar
              cualquier momento. Disfruta de una explosión de sabor, aroma y
              textura en cada mordida.
            </Typography>
            {/* <Button
              variant="contained"
              className="product-square-button"
              sx={{
                backgroundColor: "#E66671",
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "20px",
                padding: "8px 20px",
                "&:hover": {
                  backgroundColor: "#C04D5E",
                },
              }}
            >
              VER TODOS LOS PRODUCTOS
            </Button> */}
          </Box>

        </Box>
      </Box>
    </Box>
  );
}

export default Products;